import { render } from "./GoodStandingSectionApplicant.vue?vue&type=template&id=61150bde&scoped=true"
import script from "./GoodStandingSectionApplicant.vue?vue&type=script&lang=js"
export * from "./GoodStandingSectionApplicant.vue?vue&type=script&lang=js"

import "./GoodStandingSectionApplicant.vue?vue&type=style&index=0&id=61150bde&lang=postcss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61150bde"]])

export default __exports__